<template>
    <div class="Packageconfiguration">
        <div class="header">
            <div class="item">套餐名称：<el-input v-model="params.packageName" clearable placeholder="请输入套餐名查询" style="width:240px;"></el-input></div>
            <div class="item">套餐编码：<el-input v-model="params.packageCode" clearable placeholder="请输入套餐编码查询" style="width:240px;"></el-input></div>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button  @click="reset">重置</el-button>

        </div>
        <div class="Main">
            <el-button type="primary" style="margin-bottom: 20px;" @click="editdrawer=true;isedit=false">新增条件</el-button>
            <el-table
            v-loading="loading"
            :data="comprehensiveData"
            >
            <el-table-column label="序号" width="50">
                <template slot-scope="scope" center>
                {{ (params.pageIndex - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>    
            <el-table-column prop="packageName" label="套餐名称"></el-table-column>
            <el-table-column prop="packageCode" label="套餐编码"></el-table-column>
            <el-table-column prop="describe" label="备注"></el-table-column>
            <!-- <el-table-column prop="lineNumber" label="排序"></el-table-column> -->
            <el-table-column prop="isActive" label="是否启用" :formatter="(row)=>row.isActive==1?'启用':'未启用'"></el-table-column>
            <el-table-column prop="createdDate" sortable label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <div class="handle">
                        <span @click="clickedit(scope.row)">修改</span>
                        <el-popconfirm title="是否确认删除该条记录？" @confirm="confirmDetail(scope.row)">
                            <span slot="reference">删除</span>
                        </el-popconfirm>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination
                @current-change="handleCurrentChange"
                hide-on-single-page
                :current-page.sync="params.pageIndex"
                :page-size="params.pageSize"
                layout="total, prev, pager, next"
                :total="params.Total">
            </el-pagination>
        </div>

        <!-- 修改 -->
        <el-drawer
            :visible.sync="editdrawer" title="新建套餐">
            <el-form :model="Packageparams" :rules="rules" ref="Packageparams" style="width:90%;margin: auto;">
                <el-form-item label="套餐名称" prop="packageName">
                    <el-input v-model="Packageparams.packageName" ></el-input>
                </el-form-item>
                <el-form-item label="选择量表" prop="paperIDs">
                    <el-cascader  
                        v-model="Packageparams.paperIDs" 
                        :options="scalelist"
                        :props="{label:'PaperName',value:'PaperCode',children:'LiPaper',multiple:true,emitPath:false}"
                        :show-all-levels="false"
                        node-key="PaperCode"
                        ref="tree"
                        @change="handleChange" style="width:100%;">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="套餐编码" prop="packageCode">
                    <el-input v-model="Packageparams.packageCode" ></el-input>
                </el-form-item>
                <el-form-item label="是否启用" prop="isActive">
                    <el-radio-group v-model="Packageparams.isActive">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="Packageparams.describe" ></el-input>
                </el-form-item>
                <el-form-item style="margin-top:20px;">
                    <el-button type="primary" @click="confirmedit('Packageparams')">确定</el-button>
                    <el-button @click="editdrawer=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>

    </div>
</template>
<script>
export default{
    name:'Packageconfiguration',
    data() {
        return {
            loading:true,
            editdrawer:false,
            isedit:false,
            rules:{
                packageName:[{ required: true, message: '请输入套餐名称', trigger: 'blue' }],
                paperIDs:[{ required: true, message: '请选择量表', trigger: 'change' }],
                packageCode:[{ required: true, message: '请输入编码', trigger: 'blue' }],
                isActive:[{ required: true, message: '请选择是否启用', trigger: 'change' }],
            },
            params:{
                packageCode:'',
                pageIndex:1,
                pageSize:10,
                Total:0,
                describe:'',
                packageName:''
            },
            Packageparams:{
                packageKey:'',
                packageName:'',
                describe:'',
                paperIDs:[],
                isActive:'',
                packageCode:''
            },
            comprehensiveData:[],
            scalelist:[],
        }
    },
    created() {
        this.getpackagelist();
        this.querypaper();
    },
    methods: {

        handleCurrentChange(val){
            this.params.pageIndex=val;
            this.getpackagelist();
        },
        search(){
            this.params.pageIndex=1;
            this.getpackagelist();
        },

        // 获取列表
        getpackagelist(){
            this.loading=true;
            this.$Http_Post('querypaper/getpackagelist',this.params).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.params.Total=res.Counts;
                    this.comprehensiveData=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 重置
        reset(){
            this.params=this.$options.data().params;
            this.getpackagelist();
        },
        // 获取所有量表
        querypaper(){
                this.$Http_Post('ScaleIssue/GetShowScale',{Tiaojian:''}).then(res=>{
                    if(res.Code==200 || res.Code==0){
                        this.scalelist=res.Data;
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                });
            },
        // 删除记录
        confirmDetail(val){
            this.$Http_Post('querypaper/delpackage',{packageKey:val.packageKey}).then(res=>{
                if(res.Code==0){
                    this.$message({type: 'success', message:res.Message});
                    this.getpackagelist();
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 打开修改弹窗
        clickedit(val){
            this.editdrawer=true;
            this.isedit=true;
            this.Packageparams.paperIDs=[];
            this.Packageparams.packageKey=val.packageKey;
            this.Packageparams.packageCode=val.packageCode;
            this.Packageparams.packageName=val.packageName;
            this.Packageparams.describe=val.describe;
            this.Packageparams.isActive=val.isActive;
            for(let item of val.tpmsPackagePapers){
                this.Packageparams.paperIDs.push(item.paperID);
            }
        },
        confirmedit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let URL=this.isedit?'querypaper/updatepackage':'querypaper/savepackage';
                    this.$Http_Post(URL,this.Packageparams).then(res=>{
                        if(res.Code==0){
                            this.getpackagelist();
                            this.editdrawer=false;
                            this.$message({type: 'success', message:res.Message});
                        }else{
                            this.$message({type: 'error', message:res.Message});
                        }
                    });
                }
            })
        },
        handleChange(checkedNodeKeys){
            this.Packageparams.paperIDs=checkedNodeKeys
        },
    },
}
</script>
<style>
.Packageconfiguration .header{background: #fff;padding: 20px;}
.Packageconfiguration .header .item{display:inline-block;margin-right: 30px;}
.Packageconfiguration .Main{margin: 20px 0;background: #fff;padding:20px;}
.Packageconfiguration .handle span{color: #0088FF;padding:0 5px;cursor: pointer;}
.Packageconfiguration .condition{width: 260px;min-height:400px;}
.Packageconfiguration .el-textarea__inner{min-height:260px!important;}
.Packageconfiguration .el-form-item{margin: 0;}
.Packageconfiguration .el-drawer__header{margin: 0;}
</style>